import { HOST } from "../constants";

export const getImageURL = (path) => {
    if (path.includes("http")) {
        return path;
    } else {
        return HOST + path;
    }
};
